import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyRefundBillItem from './pharmacy-refund-bill-item';
import PharmacyRefundBillItemDetail from './pharmacy-refund-bill-item-detail';
import PharmacyRefundBillItemUpdate from './pharmacy-refund-bill-item-update';
import PharmacyRefundBillItemDeleteDialog from './pharmacy-refund-bill-item-delete-dialog';

const PharmacyRefundBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyRefundBillItem />} />
    <Route path="new" element={<PharmacyRefundBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyRefundBillItemDetail />} />
      <Route path="edit" element={<PharmacyRefundBillItemUpdate />} />
      <Route path="delete" element={<PharmacyRefundBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyRefundBillItemRoutes;
